export const intlConstants = {
  SET_LOCALE: 'SET_LOCALE',
};
